import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getAdminInfo = (axios: IAxiosInstance) => {
  return async ({
    usePrimaryCookie = true,
  }: ISchema["#/definitions/IGetAdminInfoArgs"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetAdminInfoResponse"]
    >(`/api/getAdminInfo`, {
      params: { usePrimary: usePrimaryCookie },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
